// extracted by mini-css-extract-plugin
export default {"component":"ProgressBar__component--slots-SPmF2","status":"ProgressBar__status--slots-Uu7HZ"};